// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { observer, useLocalObservable } from "mobx-react-lite";
import environment from "@environment";
import { useEffectOnce } from "@lib-shared/hooks";
import MapWithMarkersStore from "@lib-shared/stores/map/map-with-markers.store";
import MenuApp from "@menu/app";
import getSiteAndCulture from "@menu/core/lib/get-site-and-culture";
import AppConfig from "core/app-config";
import { Country, findCountryByCode } from "core/countries";
import SearchStore from "core/stores/search.store";
import Search from "components/search";

const defaultCountryCode = environment.defaultCountryCode;
const mapConfig = environment.map;

const getCoordinates = (country: Country) => {
  if (!AppConfig.countryLatitude || !AppConfig.countryLongitude) {
    return country.coordinates;
  }

  return {
    lat: AppConfig.countryLatitude,
    lng: AppConfig.countryLongitude
  };
}

const getCountryName = (country: Country) => {
  return !!AppConfig.countryName ? AppConfig.countryName : country.name;
}

export const App = observer(() => {
  const hideMenu = false;
  const store = useLocalObservable(() => new SearchStore());
  const mapStore = useLocalObservable(() => new MapWithMarkersStore(mapConfig.defaultCenter, mapConfig.defaultZoom));

  useEffectOnce(() => {
    const { site, culture } = getSiteAndCulture();
    const countryCode = culture.split("-")[1];
    const country = findCountryByCode(countryCode) ?? findCountryByCode(defaultCountryCode);

    const countryName = getCountryName(country!);

    store.updateCountry(countryName);

    const mapCentre = getCoordinates(country!);
    mapStore.updateCenter(mapCentre);
  });

  return (<>
    {!hideMenu && <div id="root">
      <MenuApp />
    </div>}

    <Search store={store} mapStore={mapStore} />
  </>);
});

export default App;
